import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty'; 

export const RBM_DATA_LOADING = "RBM_DATA_LOADING";
export const RBM_DATA_SUCCESS = "RBM_DATA_SUCCESS";
export const RBM_DATA_FAILED = "RBM_DATA_FAILED";


export const RBM_DETAILS_LOADING = "RBM_DETAILS_LOADING";
export const RBM_DETAILS_SUCCESS = "RBM_DETAILS_SUCCESS";
export const RBM_DETAILS_FAILED = "RBM_DETAILS_FAILED";


export const getRbmdetails = () => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: RBM_DETAILS_LOADING});
        
        let failedType :string = RBM_DETAILS_FAILED;

        let url: string = `/rbm`;

        networkCall("get", url, apiBaseUrl.baseUrl)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({ type: RBM_DETAILS_SUCCESS, payload: {respose: res}});
            }else{
                dispatch({ type: failedType, payload: {error: res}});
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: failedType, payload: {error: error.response.data}});
            }
        });
    }

}


export const saveRequest = (data: any, cb:  (message: string, status: boolean) => void) => {
    return (dispatch:Dispatch<any>) => {
        
        let url: string = `/rbm`;

        networkCall("post", url, apiBaseUrl.baseUrl, true, true, data)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                cb(res, true);
            }else{
                cb(res, false);
            }
        }).catch((error)=>{
            if(error?.response?.data){
                cb(error.response.data.message, false);
            }
        });
    }

}
